import React from "react";

export default function Spacer({ w = 0, h = 0 }) {
  return <div style={{ minWidth: w, minHeight: h }}></div>;
}
